var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinColor = function SvgLinkedinColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A66C2",
    fillRule: "evenodd",
    d: "M33.611 2.5H6.39A3.89 3.89 0 0 0 2.5 6.389V33.61A3.89 3.89 0 0 0 6.389 37.5H33.61a3.89 3.89 0 0 0 3.889-3.889V6.39A3.89 3.89 0 0 0 33.611 2.5M13.083 32.639H7.862V15.785h5.22zm-2.635-19.06c-1.706 0-3.087-1.39-3.087-3.112 0-1.72 1.38-3.11 3.087-3.11 1.706 0 3.087 1.39 3.087 3.11 0 1.721-1.38 3.111-3.087 3.111m22.19 19.06h-5.19v-8.847c0-2.426-.924-3.782-2.84-3.782-2.09 0-3.179 1.41-3.179 3.782v8.847h-5.007V15.785h5.007v2.27s1.507-2.785 5.08-2.785 6.135 2.183 6.135 6.699v10.67z",
    clipRule: "evenodd"
  })));
};
export default SvgLinkedinColor;